import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react';

import { useSite } from '../context/site';
import { NAME } from '../shared';

function LanguageDropdown({ languageId, onChange }) {
    const { lists } = useSite();

    const [language, setLanguage] = useState(languageId || '');
    const [languages, setLanguages] = useState([]);
    const [languagesLoaded, setLanguagesLoaded] = useState(false);

    const languageOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.itemName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const selectedLanguageTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div className={!option.active ? 'text-red-500' : ''}>{option.itemName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    useEffect(() => {
        if (language) {
            onChange(language);
        }
    }, [language, onChange]);

    useEffect(() => {
        if (!languagesLoaded) {
            const _languages = !!languageId
                ? lists.filter((l) => l.listType === NAME.listType.language)
                : lists.filter((l) => l.active && l.listType === NAME.listType.language);

            setLanguages(_languages);
            setLanguagesLoaded(true);

            setLanguage(languageId ? languageId : _languages.find((g) => g.itemIsDefault)._id);
        }
    }, [lists, languageId, languagesLoaded]);

    return (
        <Dropdown
            value={language}
            valueTemplate={selectedLanguageTemplate}
            onChange={(e) => setLanguage(e.value)}
            options={languages.sort((a, b) => (a.itemName > b.itemName ? 1 : -1))}
            itemTemplate={languageOptionTemplate}
            optionLabel="itemName"
            optionValue="_id"
            placeholder="Select a Language"
        />
    );
}

export default LanguageDropdown;
